<template>
  <b-modal @hide="modalClose" ref="productShapeModal" :title="$t('製品形状')" size="xl">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr class>
            <th class="bg-light text-left">{{ $t('製品形状') }}</th>
            <td class="text-left">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="shapeType1"
                  value="round"
                />
                <label class="form-check-label" for="shapeType1">{{ $t("丸") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="shapeType2"
                  value="corner"
                />
                <label class="form-check-label" for="shapeType2">{{ $t("角") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="shapeType3"
                  value="plate"
                />
                <label class="form-check-label" for="shapeType3">{{ $t("板") }}</label>
              </div>
            </td>
            <th class="bg-light text-left">{{ $t('寸法') }}</th>
            <td class="text-left">
              <template v-if="form.shapeType === 'round'">
                <span class="mr-2">&Phi;</span>
              </template>
              <template v-if="form.shapeType === 'plate'">
                <span class="mr-2">t</span>
              </template>
              <div class="form-check form-check-inline shapeValues">
                <template v-for="(item,index) in form.shapeValues">
                  <span :key="index">
                    <input
                      v-model.number="form.shapeValues[index]"
                      type="number"
                      min="0"
                      class="form-control wf-60"
                    />
                  </span>
                </template>
                <span v-if="form.shapeType" class="ml-2">mm</span>
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-light text-left">{{ $t('重量') }}</th>
            <td class="text-left">
              <div class="input-group">
                <input
                  v-model.number="form.shapeWeight"
                  type="number"
                  min="0"
                  class="form-control input"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{ $t('kg') }}</span>
                </div>
              </div>
            </td>
            <th class="bg-light text-left">{{ $t('寸法備考') }}</th>
            <td class="text-left">
              <input v-model="form.shapeNote" type="text" class="form-control" />
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    oldForm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {},
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen() {
      this.$refs.productShapeModal.show()
      this.form = this.mixin_deepcopy(this.oldForm)
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$emit('modalClose')
      this.$refs.productShapeModal.hide()
    },
    shapeTypeChange() {
      if (this.form.shapeType === 'round') {
        this.form.shapeValues = [0, 0]
      } else if (this.form.shapeType == 'corner' || this.form.shapeType == 'plate') {
        this.form.shapeValues = [0, 0, 0]
      } else {
        this.form.shapeType = []
      }
    },
    async register() {
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        params[key] = this.form[key]
      }
      try {
        await this.$axios({
          method: 'put',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/product`,
          data: params,
        })
        this.$toasted.success(this.$t('編集が完了しました。'))
        this.$emit('registered')
        this.$refs.productShapeModal.hide()
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
